export const api = {
  host: 'https://bfh.api.flowsmart.ai'
};
